export default class TealAndOrange {

    constructor() {
        this.blockName = 'teal-and-orange';
        this.control = 'LUTsliders';
        this.defaultOpacity = 50;
        this.maxValue = 100;
        this.minValue = 0;
        this.orderOfLUT = ['Orange', 'Teal', 'Neutral Tint'];
        this.opacity = {
            minValue: 0,
            maxValue: 100,
        };
    }
    
    async addBlock(blockNum = lutify.blocks.length, data) {
        data.control = this.control;

        UI.createAdjustmentBlockTemplate(this.blockName, blockNum, data);
        let $element = $(UI.getAdjustmentBlock(blockNum));

        $element.trigger('click');
        
        $element.find('.adjustmentBlock-slider').on('input', e => {
            blocks.checkSwitchHandler($element);
            this.sliderHandler(e.currentTarget)
        });
        $element.find('.adjustmentBlock-range').on('change', e => {
            blocks.checkSwitchHandler($element);
            this.rangeHandler(e.currentTarget)
        });

        $element.find(".opacity_slider").on("input", () => this.opacitySliderHandler($element));
        $element.find(".opacity-input").on("change", () => this.opacityInputHandler($element));

        blocks.add({
            name: "tealAndOrange",
            control: data.control,
            category: data.category,
            passes: [null, null, null],
            blockNum,
            blendingMode: 0,
            blendingModeName: 'Normal',
            opacity: 100,
            values: {
                teal: 50,
                orange: 50,
                neutralTint: 50
            }
        });

        UI.appendBlockLoadingSpinner($element);
        await this.load(data);
        UI.removeBlockLoadingSpinner($element);

        // NOTE maybe need to re-write : add empty pass then replace with lut pass (like we do with LUTcontrols when a selection is made)
        lutify.getActiveBlock().passes = this.addPasses(data.category);
        
        $element.find('.expand_options').trigger('click', [false]);
        $element.find('.controls-wrapper .switch input').trigger('click');
        UI.scrollToBlock(blockNum);
    }


    async load(data) {
         // Initially when loading for first time.
         if (typeof luts.loaded[data.control].controls[data.category] == 'undefined') {
            luts.loaded[data.control].controls[data.category] = { status:'idle', total: null, fetched: null };
            luts[data.control][data.category] = [];
        }

        // When all luts fetched, don't fetch again.
        if (luts.loaded[data.control].controls[data.category].status == 'loaded') return;

        if (luts.loaded[data.control].controls[data.category].status == 'idle') {
            luts.loaded[data.control].controls[data.category].status = 'loading';

            let fetchedLUTs = await luts.fetchLUTcontrols(data);
            await luts.load(fetchedLUTs, luts[data.control][data.category]);

            luts[data.control][data.category].forEach((LUT, key) => {
                LUT.control = data.control;
                LUT.category = data.category;
            });

            luts.loaded[data.control].controls[data.category].fetched += fetchedLUTs.length;
            luts.loaded[data.control].controls[data.category].status = 'loaded';
        }

         // If we add more of the same block while the initial is being in 'loading'
         else if (luts.loaded[data.control].controls[data.category].status == 'loading') {
            return await new Promise(resolve => {
                let interval = setInterval(_ => {
                    if (luts.loaded[data.control].controls[data.category].status == 'loaded') {
                        clearInterval(interval);
                        resolve();
                    }
                }, 500);
            });
        }
    }
    
    
    addPasses(category) {
        let passes = [];
        this.orderOfLUT.forEach(lutName => {
            luts[this.control][category].forEach(LUT => {
                if (lutName == LUT.title) {
                    let pass = gpu.createLUTPass(LUT.texture);
                    pass.uniforms.opacity.value = this.defaultOpacity * 0.01;
                    pass.LUTtitle = LUT.title;
                    passes.push(pass);
                    gpu.addPassToComposer(pass, 'toMiddle');
                }
            })
        });
        return passes;
    }


    sliderHandler(el) {
        let controlName = $(el).data('name');
        let passIndex = $(el).data('pass-index');
        let sliderValue = $(el).val();
        
        $(el).siblings(`[data-name="${controlName}"]`).val(sliderValue);
        lutify.getActiveBlock().values[controlName] = sliderValue;
        
        lutify.getActiveBlock().passes[passIndex].enabled = true;
        lutify.getActiveBlock().passes[passIndex].uniforms.opacity.value = sliderValue * 0.01;
        gpu.render()
    }


    rangeHandler(el) {
        let controlName = $(el).data('name');
        let passIndex = $(el).data('pass-index');
        let rangeValue = $(el).val();

        if (rangeValue > this.maxValue) {
            rangeValue = this.maxValue;
            $(el).val(rangeValue);
        }
        if (rangeValue < this.minValue) {
            rangeValue = this.minValue;
            $(el).val(rangeValue);
        }
        
        $(el).siblings(`[data-name="${controlName}"]`).val(rangeValue);
        lutify.getActiveBlock().values[controlName] = rangeValue;

        lutify.getActiveBlock().passes[passIndex].enabled = true;
        lutify.getActiveBlock().passes[passIndex].uniforms.opacity.value = rangeValue * 0.01;
        gpu.render()
    }

    opacitySliderHandler($element) {
        let opacityValue = $element.find(".opacity_slider").val();
        let calcOpacityValue = opacityValue * 0.01;

        $element.find(".opacity-input").val(opacityValue);

        lutify.getActiveBlock().opacity = opacityValue;
        lutify.getActiveBlock().passes.forEach(pass => {
            pass.uniforms.opacity.value = calcOpacityValue;
        })

        gpu.render();
    }

    opacityInputHandler($element) {
        let opacityValue = $element.find(".opacity-input").val();
        let opacitySlider = $element.find(".opacity_slider");

        if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
        if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

        opacitySlider.val(opacityValue);
        opacitySlider.trigger("input");
    }


    applyChanges($block, values, blockData) {
        Object.keys(values).forEach(value => {
            // console.log(`.range_slider[data-name="${value}"]`);
            let slider = $block.find(`.range_slider[data-name="${value}"]`);
            slider.val(values[value]);
            slider.trigger('input');
        });

        if (blockData.blendingMode !== 0) $block.find(`.blending-mode__items-container > span[data-id="${blockData.blendingMode}"]`).trigger('click');

        if ('opacity' in blockData) {
            $block.find(".opacity-input").val(parseInt(blockData.opacity));
            $block.find(".opacity-input").trigger("change");
        }
    }
}